import feathers from '@feathersjs/client';
import { ContextCacheMap } from 'feathers-fletching';
import { cache, stashCache } from 'src/feathers/hooks';
import { scriptLoader } from 'straightline-ui';
const { GeneralError } = feathers.errors;

class Service {
  constructor(options) {
    this.options = options;
  }

  async find(params) {
    if (!this.directionsService) {
      await scriptLoader.load(process.env.REACT_APP_GOOGLE_MAPS_URL);
      this.directionsService = new window.google.maps.DirectionsService();
    }
    const googleParams = {
      travelMode: window.google.maps.TravelMode.DRIVING,
      ...params.query
    };
    return new Promise((resolve, reject) => {
      this.directionsService.route(googleParams, (response, status) => {
        if (status !== 'OK') {
          reject(
            new GeneralError(
              'There was an error from Google calculating the directions.',
              { status }
            )
          );
        } else {
          resolve(response);
        }
      });
    });
  }
}

export default (app) => {
  const cacheMap = new ContextCacheMap({
    max: 50,
    ttl: 1000 * 60 * 60 * 24 * 7,
    ttlResolution: 1000 * 60 * 60 * 10,
    ttlAutopurge: true
  });

  app.storage
    .get('google/directions')
    .then((cache) => {
      if (cache) {
        try {
          cacheMap.map.load(JSON.parse(cache));
        } catch (error) {}
      }
    })
    .catch((error) => {
      app.get('sentryClient').captureException(error, {
        method: 'get',
        path: 'storage:google/directions'
      });
    });

  const options = { cacheMap };
  app.use('google/directions', new Service(options));
  const service = app.service('google/directions');

  service.hooks({
    before: {
      all: [],
      find: [cache],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    },

    after: {
      all: [],
      find: [cache, stashCache()],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};
